import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { BasePagingResponse } from "../_types";

export interface TaxRate {
  id: number;
  name: string;
  rate: number;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE";
  merchantId: number;
}

export interface GetTaxRatesRequest {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status?: string;
}

export type GetTaxRatesResponse = BasePagingResponse<Array<TaxRate>>;

async function getTaxRates(
  request: GetTaxRatesRequest
): Promise<GetTaxRatesResponse> {
  try {
    return (await axiosInstance.post("/Product/GetTaxRates", request)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetTaxRates() {
  const defaultRequest: GetTaxRatesRequest = {
    page: 1,
    size: 100,
    orderByDesc: false,
    orderBy: "MerchantId",
    status: "ACTIVE"
  };

  return useQuery<GetTaxRatesResponse, Error>(
    ["product", "tax-rates"],
    () => getTaxRates(defaultRequest),
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }
  );
}
